// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import file04Icon from "@/assets/icons/file-04.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type File04IconProps = Omit<IconProps, "name">;

export function File04Icon(props: File04IconProps): React.ReactNode {
  return <Icon name={file04Icon} {...props} />;
}
